import { Autocomplete, Box, Button, Chip, IconButton, Sheet, Stack, Typography } from '@mui/joy';
import { useMemo } from 'react';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ScheduleTimeFields from './ScheduleTimeFields';
import { changeDateSet } from './schedule';

export default function ApplicationScheduleFields({form, onChange, options, renderCalendar, error, showTimezone = true}) {
  const zones = useMemo(() => {
    try { return [...new Set(['UTC', form.schedule_timezone, ...Intl.supportedValuesOf('timeZone')].filter(Boolean))]; }
    catch (_) { return [...new Set(['UTC', form.schedule_timezone, 'Europe/Moscow', 'Asia/Yekaterinburg'].filter(Boolean))]; }
  }, [form.schedule_timezone]);
  const slots = form.desired_slots || [];
  const setDates = dates => onChange({desired_dates: dates, desired_slots: changeDateSet(slots, dates)});
  const setSlot = (date, value) => onChange({desired_slots: slots.map(slot => slot.date === date ? {...slot, ...value} : slot)});
  return <Box sx={{gridColumn: '1 / -1', minWidth: 0}}>
    <Stack direction="row" gap={1} flexWrap="wrap" role="group" aria-label="Когда нужна услуга">
      {options.map(option => <Button key={option.value} size="sm" variant={form.desired_time === option.value ? 'solid' : 'outlined'}
        color={form.desired_time === option.value ? 'primary' : 'neutral'} aria-pressed={form.desired_time === option.value}
        onClick={() => {
          const desired = form.desired_time === option.value ? '' : option.value;
          onChange({desired_time: desired, desired_date: '',
            ...(desired !== 'pick_dates' ? {desired_dates: [], desired_slots: []} : {}),
            preferred_time_mode: 'any', preferred_time_from: '', preferred_time_to: ''});
        }} sx={{borderRadius: 'lg', whiteSpace: 'normal', textAlign: 'left'}}>{option.label}</Button>)}
    </Stack>
    {showTimezone && form.desired_time !== 'representative' && <Box sx={{mt: 1.5}}>
      <Typography level="body-xs" sx={{mb: 0.5}}>Часовой пояс объекта для всех дат и времени</Typography>
      <Autocomplete options={zones} value={form.schedule_timezone || null} size="sm"
        onChange={(_, value) => onChange({schedule_timezone: value || ''})} placeholder="Выберите часовой пояс объекта"
        slotProps={{listbox: {sx: {zIndex: 100025}}, input: {'aria-label': 'Часовой пояс объекта заявки'}}}/>
      <Typography level="body-xs" sx={{mt: 0.5, color: 'text.tertiary'}}>Проверьте часовой пояс адреса объекта; время ниже указано в нём.</Typography>
    </Box>}
    {form.desired_time === 'representative' ? <Sheet variant="soft" color="primary" sx={{p: 1.5, mt: 1.5, borderRadius: 'md'}}>
      <Typography level="body-sm">Менеджер сам согласует дату и время со встречающим, указанным в блоке «Контакт на объекте».</Typography>
    </Sheet> : form.desired_time === 'pick_dates' ? <Box sx={{mt: 1.5}}>
      <Typography level="body-sm" sx={{mb: 1}}>Выберите удобные дни. У каждого дня можно указать своё время прибытия.</Typography>
      {renderCalendar({selectedDates: slots.map(slot => slot.date), onChange: setDates})}
      <Stack spacing={1.25} sx={{mt: slots.length ? 1.5 : 0}}>
        {slots.map(slot => <Sheet key={slot.date} data-schedule-date={slot.date} variant="outlined" sx={{p: 1.25, borderRadius: 'md', minWidth: 0}}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb: 0.5}}>
            <Chip size="sm" color="primary" variant="soft">{slot.date.split('-').reverse().join('.')}</Chip>
            <IconButton size="sm" variant="plain" color="neutral" aria-label={`Убрать дату ${slot.date}`}
              onClick={() => setDates(slots.filter(item => item.date !== slot.date).map(item => item.date))}><CloseRoundedIcon sx={{fontSize: 16}}/></IconButton>
          </Stack>
          <ScheduleTimeFields value={slot} onChange={value => setSlot(slot.date, value)} label={`Прибытие ${slot.date}`}/>
        </Sheet>)}
      </Stack>
    </Box> : <Box sx={{mt: 1.5}}>
      <Typography level="body-sm" sx={{mb: 0.75}}>Предпочтительное время прибытия</Typography>
      <ScheduleTimeFields value={{mode: form.preferred_time_mode, time_from: form.preferred_time_from, time_to: form.preferred_time_to}}
        onChange={value => onChange({preferred_time_mode: value.mode, preferred_time_from: value.time_from, preferred_time_to: value.time_to})}/>
    </Box>}
    {error && <Typography color="danger" level="body-sm" role="alert" sx={{mt: 1}}>{error}</Typography>}
  </Box>;
}
